
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[search]",
      function () {
        return require("private-next-pages/search/[search]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[search]"])
      });
    }
  